import { ArrowRight } from "lucide-react";

/**
 * Blocos da prévia de importação de planilha: `Numero`, `Secao` e `Mudanca`.
 * Quem monta a prévia é a planilha de Produtos (features/cardapio-planilha),
 * usada também pelo Módulo Fiscal desde 02/10/2026.
 */

export function Numero({ icone: Icone, valor, rotulo, cor }) {
  return (
    <div className="rounded-xl border bg-card p-3">
      <div className={`flex items-center gap-1.5 text-xs font-medium ${cor}`}>
        <Icone className="w-3.5 h-3.5" />
        {rotulo}
      </div>
      <div className="text-2xl font-bold tabular-nums mt-1">{valor}</div>
    </div>
  );
}

export function Secao({ titulo, total, aberta, children }) {
  if (!total) return null;
  return (
    <details open={aberta} className="rounded-xl border bg-card">
      <summary className="cursor-pointer select-none px-4 py-2.5 text-sm font-semibold">
        {titulo} <span className="text-muted-foreground font-normal">({total})</span>
      </summary>
      <div className="border-t divide-y max-h-64 overflow-y-auto">{children}</div>
    </details>
  );
}

export function Mudanca({ m }) {
  return (
    <div className="px-4 py-2.5">
      <div className="text-sm font-medium">
        {m.produto} <span className="text-xs text-muted-foreground font-normal">· {m.categoria}</span>
      </div>
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
        {m.campos.map((c) => (
          <span key={c.campo} className="text-xs text-muted-foreground inline-flex items-center gap-1">
            <span className="font-medium text-foreground">{c.campo}:</span>
            <span className={c.antes ? "line-through" : "italic"}>{c.antes || "vazio"}</span>
            <ArrowRight className="w-3 h-3" />
            <span className="font-semibold text-emerald-600 dark:text-emerald-400">{c.depois}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
